export default {
  default: {
    currentPage: 5,
    totalItems: 50,
    itemsPerPage: 5
  }
}
